import { JoinRequestError } from "../play-model"
import { useMessages } from "../language/language"
import "./login-component.less"
import ActionInput, { ActionInputSize } from "../components/action-input"
import StudentNotPlayingLayout from "../layouts/student-not-playing-layout"
import { useMemo, useState } from "react"
import { classNames, hasText } from "utils/helpers"
import { usePlayState } from "play/hooks/use-play-state"

interface Props {
  className?: string
  inputSize: ActionInputSize
  label: string
  actionButtonText: string
  value: string
  isEnabled: boolean
  onInputChanged: (value: string) => void
  onActionClicked: () => void
  type: "login"|"gamecCode"
}

export default function LoginComponent(props: Props) {
  const {
    inputSize,
    label,
    actionButtonText,
    onInputChanged,
    onActionClicked,
    value,
    isEnabled,
  } = props

  const { joinError, serverError, loginUrl, classId } = usePlayState()
  const immediateLogin = hasText(classId)
  const msg = useMessages()
  const valueHasText = hasText(value)
  const [hasChanges, setHasChanges] = useState(false)

  function handleOnActionClicked() {
    if (valueHasText) {
      onActionClicked()
    }
  }

  function handleInputTextChanged(value: string) {
    const newValueHasText = hasText(value)

    if (hasChanges && !newValueHasText) {
      setHasChanges(false)
    } else {
      setHasChanges(true)
    }
    onInputChanged(value)
  }

  const errorText = useMemo(
    function () {
      if (!valueHasText && hasChanges) {
        return msg.joinErrorToString(JoinRequestError.gameCodeMissing)
      }
      if (joinError != null) {
        if (
          !valueHasText &&
          !hasChanges &&
          joinError === JoinRequestError.requireUsername
        ) {
          return null // no error
        }

        if (joinError !== JoinRequestError.none) {
          return msg.joinErrorToString(joinError)
        }
      }
      if (serverError !== null) {
        return msg.serverErrorToString(serverError)
      }
      return null
    },
    [serverError, joinError, valueHasText, hasChanges]
  )

  return (
    <StudentNotPlayingLayout
      className={classNames("login-component", props.className)}
    >
      <div className="login-component-content" data-type={props.type}>
        <ActionInput
          label={label}
          actionButtonText={actionButtonText}
          inputText={value}
          errorText={errorText}
          loginUrl={loginUrl}
          immediateLogin={immediateLogin}
          inputSize={inputSize}
          isEnabled={isEnabled}
          onInputTextChanged={handleInputTextChanged}
          onActionClicked={handleOnActionClicked}
        />
      </div>
    </StudentNotPlayingLayout>
  )
}
